import { useEffect, useState } from "react";

const ItemInstitucion = (props) => {
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const listDataElement = document.querySelector(".list-item");

    if (listDataElement.clientHeight > 400) {
      setIsOverflow(true);
    }
  }, []);

  const groupedData = props.data.reduce((letter, element) => {
    const { title } = element;
    const firstLetter = title.charAt(0).toUpperCase();

    if (!letter[firstLetter]) {
      letter[firstLetter] = [];
    }
    letter[firstLetter].push(element);

    return letter;
  }, {});

  return (
    <div className={`search-data ${isOverflow ? "overflow-y-scroll" : ""}`}>
      <div className="list-item">
        {Object.keys(groupedData).map((letter) => (
          <div key={letter}>
            <span className="letter">{letter}</span>
            <div className="item-data-search">
              {groupedData[letter].map((element) => {
                const { id, title, link } = element;
                const htmlLang = document.documentElement.lang;
                const baseUrl = link.split('.org')[0] + '.org';
                const urlPath = new URL(link);
                const pathAfterDomain = urlPath.pathname;

                const isLangEnUS = htmlLang === "en-US";

                const finalLink = isLangEnUS ? `${baseUrl}/en${pathAfterDomain}` : `${baseUrl}${pathAfterDomain}`;

                return (
                  <div key={id} className="item-result">
                    <a href={finalLink} className="item-redirect">
                      {title}
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ItemInstitucion;
